export default {"src":"/_next/static/media/ic-next-gray.997e4ea9.svg","height":8,"width":6,"blurWidth":0,"blurHeight":0};